export const HYDRATION_ID_ATTRIBUTE = 'data-hydration-id';
export const HYDRATION_TRIGGER_ATTRIBUTE = 'data-hydration-trigger';

/**
 * Use same intersection offset as next/image for lazy loading images.
 * @see https://github.com/vercel/next.js/blob/1f9e958e97253eabdcf488c4787547fda0ef75e7/packages/next/client/image.tsx#L323
 */
export const INTERSECTION_OBSERVER_ROOT_MARGIN = '200px';
